export default "__VITE_ASSET__FCRqxH7S__"